//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { selectContractById, updateContStatus, approveContract, syncContract } from "@/api/contract/contract";
	import { BASIC, JPT_URL } from "@/config/constant"
	import promise from '@/axios/promise';
	import { Toast } from 'mint-ui';

	export default {
		name: "humanDayServiceDetail",
		data() {
			return {
				contract: {},
				approve: false,
				trunDialog: false,
				passDialog: false,
				trunMessage: '',
				passMessage: '',
				businessKey: this.$route.query.cid,
				contCateCode: this.$route.query.contCateCode,
				contTypeCode: this.$route.query.contTypeCode,
				gobackName: this.$route.query.gobackName,
				columns: [{
						title: '角色',
						name: 'roleName',
					},
					{
						title: '级别',
						name: 'lvlName',
					},
					{
						title: '人天单价(含税)',
						name: 'unitPrice',
					},
				],
				taskParam: {},
				appParams: {},
			}
		},
		created() {
			if(this.$route.query.taskParam != undefined) {
				this.taskParam = this.$route.query.taskParam;
				if(this.$route.query.taskParam.taskType == 'undo') {
					this.approve = true;
					this.appParams.taskDefinitionKey = this.$route.query.taskParam.taskDefinitionKey;
					this.appParams.taskId = this.$route.query.taskParam.taskId;
				}
			}
			var data = {
				'contractId': this.$route.query.cid
			};
			selectContractById(data).then(response => {
				this.contract = response;
			});
		},
		methods: {
			/******文件预览start***************/
			preview(fileId) {
				var url = JPT_URL + BASIC + "/doc/preview?docId=" + fileId;
				this.JX_download(url);
			},

			// 下载最新版本
			JX_download(url) {
				plus.nativeUI.showWaiting("下载中...");
				//创建下载管理对象
				var SX_down = plus.downloader.createDownload(url, {}, function(d, status) {
					// 下载完成
					if(status == 200) {
						plus.nativeUI.closeWaiting();
						//下载成功后的回调函数
						// plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
						plus.runtime.openFile(d.filename, {}, function(e) { //调用第三方应用打开文件
							plus.nativeUI.toast('打开失败');
						});

					} else {
						plus.nativeUI.closeWaiting();
						plus.nativeUI.toast('下载失败');
					}
				});
				SX_down.start();
			},
			/******文件预览end***************/
			returnList() {
				if(this.$route.query.taskParam != undefined) {
					this.$router.go(-2);
				} else {
					this.$router.push({
					name: '合同列表',
						params: {
							contCateCode: this.contCateCode,
							contTypeCode: this.contTypeCode,
							gobackName : this.gobackName
						}
					});
//					this.$router.push({
//						path: '/app/project/contract/contractList',
//						query: {
//							contCateCode: this.contCateCode,
//							contTypeCode: this.contTypeCode
//						}
//					})
				}
			},
			trunDownClk() {
				this.trunDialog = true;
			},
			passClk() {
				this.passDialog = true;
			},
			cancelButton() {
				this.trunDialog = false;
				this.passDialog = false;
				this.trunMessage = '';
				this.passMessage = '';
			},
			//驳回提交
			turnDownSubmit() {
				//   var params={
				//       taskId: this.taskParam.taskId,
				//       status:'E',
				//       msg:this.trunMessage,
				//       vars:{variables:{'status':'E'}},
				//   };
				// this.completeTaskByTaskId(params);
				this.appParams.id = this.contract.id;
				this.appParams.status = 'E';
				this.appParams.msg = this.trunMessage;
				this.approveCont();
			},
			//通过提交
			passSubmit() {
				// var params={
				//   taskId: this.taskParam.taskId,
				//   status:'S',
				//   msg:this.passMessage,
				//   vars:{variables:{'status':'S'}},
				// };
				// this.completeTaskByTaskId(params);
				this.appParams.id = this.contract.id;
				this.appParams.status = 'S';
				this.appParams.msg = this.passMessage;
				this.approveCont();
			},
			approveCont() {
				var data = {
					appParams: JSON.stringify(this.appParams)
				};
				approveContract(data).then(response => {
					if(response) {
						Toast({
							message: '操作成功！',
							position: 'top',
							duration: 1500,
							className: "success"
						});
						this.$router.push({
							path: "/"
						});
					} else {
						Toast({
							message: '请求错误！',
							position: 'top',
							duration: 1500,
							className: "error"
						});
					}
				});
			},
			// //流程审批
			// completeTaskByTaskId(params){
			//   promise({
			//     url:BASIC+"/task/completeTaskByTaskId?taskId="+params.taskId+"&status="+params.status+"&msg="+params.msg,
			//     method:"post",
			//     headers:{"Content-Type": "application/json" },
			//     data:JSON.stringify(params.vars),
			//   }).then(response=>{
			//     if(response.code==500){
			//       Toast({
			//         message: '请求错误！',
			//         position: 'top',
			//         duration: 1500,
			//         className:"error"
			//       });        }
			//     if(response.code==0){
			//       if(params.status=='S'){
			//         //判断是否为最后一个节点同步<<阶段>>合同并且更新状态为生效中
			//         //如果不是阶段合同只更新状态
			//         if(this.taskParam.taskDefinitionKey=="financeAudit"){
			//           this.updateContractStatus('生效中');
			//         }else{
			//           Toast({
			//             message: '操作成功！',
			//             position: 'top',
			//             duration: 1500,
			//             className:"success"
			//           });
			//           this.$router.push({path:"/"});
			//         }
			//       }else if(params.status=='E'){
			//         //驳回后更新状态
			//         this.updateContractStatus('被驳回');
			//       }
			//
			//     }
			//   });
			// },
			// updateContractStatus(status){
			//   updateContStatus({id:this.contract.id,status:status}).then(response => {
			//     if(response){
			//       Toast({
			//         message: '操作成功！',
			//         position: 'top',
			//         duration: 1500,
			//         className:"success"
			//       });
			//       this.$router.push({path:"/"});
			//     }
			//   });
			// },
		}
	}



// WEBPACK FOOTER //
// ./src/view/contract/detail/humanDayServiceDetail.vue